import { useId, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { getBillingLogLabel } from './billingData';
import CreditBalanceAfter from './CreditBalanceAfter';

export function creditOperationStatus(item, english = false) {
  if (!item?.grouped) return '';
  if (item.settlement_status === 'pending' && ['succeeded', 'failed', 'cancelled', 'waiting_confirmation'].includes(item.status)) return english ? 'Finalizing usage' : '用量结算中';
  if (item.outcome === 'partial_success') return english ? 'Partially completed' : '部分完成';
  if (item.outcome === 'no_change') return english ? 'No changes saved' : '未保存变更';
  const labels = {
    queued: ['等待执行', 'Queued'], running: ['进行中', 'In progress'], recovering: ['恢复中', 'Recovering'],
    succeeded: ['已完成', 'Completed'], failed: ['未完成', 'Failed'], cancelled: ['已停止', 'Stopped'],
    cancelling: ['正在停止', 'Stopping'], waiting_confirmation: ['待确认', 'Awaiting confirmation'],
  };
  return labels[item.status]?.[english ? 1 : 0] || (english ? 'Status unavailable' : '状态暂不可用');
}

export function isCreditOperationActive(item) {
  return item?.grouped && (item.settlement_status === 'pending' || ['queued', 'running', 'recovering', 'cancelling'].includes(item.status));
}

export default function CreditLedgerDetails({ item, english = false }) {
  const panelId = useId();
  const [open, setOpen] = useState(false);
  const locale = english ? 'en-US' : 'zh-CN';
  // Legacy standalone entries retain their existing balance display. Projected standalone
  // entries already show all useful information in the row and need no extra details request.
  if (!item.grouped) return item.id?.startsWith('entry:') ? null : <CreditBalanceAfter value={item.balance_after} english={english} />;

  return <>
    <button type="button" className="credit-operation-toggle" aria-expanded={open} aria-controls={panelId}
      aria-label={`${open ? (english ? 'Collapse' : '收起') : (english ? 'View details' : '查看明细')}：${getBillingLogLabel(item, locale)}`}
      onClick={() => setOpen(value => !value)}>
      {open ? (english ? 'Collapse' : '收起') : (english ? 'Details' : '明细')}
      <ChevronDown size={13} className={open ? 'is-open' : ''} />
    </button>
    <div id={panelId} className="credit-operation-details" hidden={!open}>
      <dl className="credit-operation-summary">
        <div><dt>{english ? 'Status' : '操作状态'}</dt><dd>{creditOperationStatus(item, english)}</dd></div>
        <div><dt>{english ? 'Model' : '使用模型'}</dt><dd>{item.model_name || '—'}</dd></div>
      </dl>
      <ul className="credit-operation-objects">
        {(item.operations || []).map((effect, index) => <li key={`${effect.kind}:${effect.action}:${index}`}>
          <strong>{english ? effect.title_en || effect.title : effect.title}</strong>
          {effect.names?.length > 0 && <span>{effect.names.join('、')}</span>}
        </li>)}
      </ul>
      {isCreditOperationActive(item) && <p className="credit-operation-caption">{english ? 'This conversation is in progress; the total will update here.' : '本轮对话进行中，合计点数会在这条记录中更新。'}</p>}
    </div>
  </>;
}
